import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { VesselDataPayload, VesselDataResponse } from "@/types/interface/vessel";

export const useVesselStore = defineStore("vesselStore", () => {
  const vessel = ref<VesselDataResponse>();
  const vessels = ref<VesselDataResponse[]>([]);

  function initVessels(data: any) {
    vessels.value = data?.data;
  }

  function addNewVessel(data: any) {
    vessel.value = data;
  }

  async function dispatchGetAll(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vessel.getVessel(page, limit, queryParam);
      if (status === 200 ) {
        initVessels(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idVessel = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vessel.findVessel(idVessel);
      if (status === 200 ) {
        addNewVessel(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload: VesselDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vessel.createVessel(payload);
      if (status === 200 ) {
        addNewVessel(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idVessel = "", payload: VesselDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vessel.updateVessel(idVessel, payload);
      if (status === 200 ) {
        addNewVessel(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idVessel = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vessel.deleteVessel(idVessel);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    vessel,
    vessels,
    initVessels,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetAll,
    dispatchDelete
  };
});